// extracted by mini-css-extract-plugin
module.exports = {"indexBg":"pageWrapper_indexBg__FGi7d","wrapper":"pageWrapper_wrapper__GwCE3"};